import {Injectable} from '@angular/core';
import {pluckResult, ProductManagementApiService} from './product-management-api.service';
import {HttpClient} from '@angular/common/http';
import {ProductSpec} from '../models/clare';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ClareApiResponse, SpecOption} from '@sportngin/se-commerce-sdk/models/clare';

@Injectable({providedIn: 'root'})
export class SpecApiService extends ProductManagementApiService {
  controllerPath = '';

  constructor(protected override http: HttpClient) {
    super(http);
  }

  create(spec: ProductSpec, itemId: number): Observable<ProductSpec> {
    const url = this.getUrl(`finance/products/${itemId}/product_specs`);
    if (spec.spec_options?.length) {
      spec.spec_options_attributes = [...spec.spec_options];
      delete spec.spec_options;
    }
    return this.POST<ClareApiResponse<ProductSpec>>(url, {product_spec: {...spec}}, {...this.requestOptions()}).pipe(
      pluckResult()
    );
  }

  createUpdate(__spec: ProductSpec): Observable<ProductSpec> {
    throw new Error('Method not implemented.');
  }

  createSpecOption(option: {specId: number; option: SpecOption}): Observable<SpecOption> {
    const body = {spec_option: {name: option.option.name}, product_spec_id: option.specId};
    const url = this.getUrl(`finance/product_specs/${option.specId}/spec_options`);

    return this.POST<ClareApiResponse<SpecOption>>(url, body, {...this.requestOptions()}).pipe(pluckResult());
  }

  deleteSpecOption(__specId: string, __optionId: string): Observable<unknown> {
    throw new Error('Method not implemented.');
  }

  protected override getUrl(path: string): string {
    return `${environment.apiBaseUrl}/${path}`;
  }
}
